<template>
	<page class="dashboard" title="Oversigt" style="background-color: #F0F0F0;">
		<button-view slot="tools" :label="edit ? 'Gem' : 'Tilpas'" @click="edit = !edit" style="display: inline-block;" />
		<button-view v-if="false" slot="tools" label="TEST" @click="test" style="display: inline-block;" />
		<div class="widgets">
			<component v-for="(widget, i) in widgets" :key="i" :is="widget.settings.is" v-model="widgets[i]" :edit="edit" :types="types" />
		</div>
	</page>
</template>

<script>
	import SvgMarker from '../SvgMarker'

	import Widget from '../widgets/Widget'
	import ListWidget from '../widgets/ListWidget'

	import { bus } from '../../bus'

	var w = {
		settings: {
			type: 'tasks',
			is: 'list-widget',
			label: 'Opgaver',
		},
		filters: {

		},
		props: {
			subtitle: 'Rødovre, Åbne, Nicolaj Andersen',
			columns: [
				{
					label: 'ID',
					name: 'id',
					weight: 1
				},
				{
					label: 'Navn',
					name: 'name',
					weight: 2
				},
				{
					label: 'E-mail',
					name: 'email',
					weight: 2
				}
			]
		},
		data: [
			{
				id: 12,
				name: 'Nicolaj Andersen',
				email: 'nicolaj.andersen@gmail.com'
			},
			{
				id: 12,
				name: 'Nicolaj Andersen',
				email: 'nicolaj.andersen@gmail.com'
			},
			{
				id: 12,
				name: 'Nicolaj Andersen',
				email: 'nicolaj.andersen@gmail.com'
			}
		]
	};

	var ew = {
		settings: {
			type: 'empty',
			is: 'widget',
			label: ''
		},
		props: {}
	};

    export default {
		data: function () {
			return {
				edit: false,
				items: [
					{ name: 'Nicolaj Andersen' },
					{ name: 'Nicolaj Andersen' },
					{ name: 'Nicolaj Andersen' },
					{ name: 'Nicolaj Andersen' },
					{ name: 'Nicolaj Andersen' },
					{ name: 'Nicolaj Andersen' },
					{ name: 'Nicolaj Andersen' }
				],
				shown: true,
				angle: 0,

				widgets: [
					
				],

				types: []
			};
		},
		watch: {
			widgets: {
				handler(n) {
					
				},
				deep: true
			},
			edit() {
				var self = this;

				this.axios
					.put('/widgets/', {
						widgets: self.widgets.map(function (item) { item.data = []; return item; })
					})
					.then(function (r) {
						
					});
			}
		},
		components: {
			svgMarker: SvgMarker,
			listWidget: ListWidget,
			widget: Widget
		},
		computed: {

		},
		methods: {
			test() {
				this.$store.commit('gps', {
					vehicle_id: 18,
					from: '2021-01-21 00:00',
					to: '2021-01-21 24:00'
				});
			},
			up() {
				this.angle += 10;
			},
			down() {
				this.angle -= 10;
			},
			beforeAppear: function (el) {
				this.$velocity(el, {
					opacity: 0,
					translateY: '50px'
				}, {
					duration: 0
				});
			},
			appear: function (el, done) {
				

				this.$velocity(el, {
					opacity: 1,
					translateY: '0px'
				}, {
					delay: 50 * el.dataset.index,
					complete: function () {
						done();
					}
				});
			},
			beforeEnter: function (el) {
				
				
			},
			show: function () {
				this.shown = true;
			},
			update() {
				var self = this;

				this.axios
					.get('/widgets/')
					.then(function (r) {
						self.widgets = r.data;

						for (var i = self.widgets.length; i < 9; ++i) {
							self.widgets.push(ew);
						}
					});
			}
		},
		mounted() {
			this.axios.put('/activity/dashboard/');

			var self = this;

			this.axios
				.get('/widgets/types/')
				.then(function (r) {
					self.types = r.data;
				});

			this.update();
		}
    }
</script>

<style lang="scss" scoped>
	.widgets {
		padding: 30px;
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		grid-template-rows: 1fr 1fr 1fr;
		grid-column-gap: 30px;
		grid-row-gap: 30px;
		height: 100%;
		min-height: 0;  /* NEW */
		min-width: 0;   /* NEW; needed for Firefox */

		& > .widget {
			min-height: 0;  /* NEW */
			min-width: 0;   /* NEW; needed for Firefox */
		}
	}

	@media only screen and (max-width: 600px) {
		.widgets {
			overflow-y: auto;
			grid-template-columns: 1fr;
			grid-auto-rows: 400px;
			grid-template-rows: none;
		}
	}
</style>